import styled from '@emotion/styled';
import React, { useEffect, useState, useRef } from 'react';
import maverickPortalhttp from '../../utils/webService/webService';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';
import AnalysisImage from './AnalysisImage';
import AnalysisVideo from './AnalysisVideo';
import { REQUEST_ANALYSIS_CLIPS_DATA } from '../../constants/analysis/analysisConstants';
import { Card, Heading, Button } from '../../common';
import copy_active from '../../images/copy_active.svg';
import copy from '../../images/copy.svg';
import AnalysisAudio from './AnalysisAudio';
import SummaryTextContainer from '../../common/SummaryTextContainer';
import loading from '../../assets/images/loading.svg';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_CHECK_SUMMARY } from '../../constants/analysis/checkSummaryConstants';
import { useParams } from 'react-router-dom';
import { REQUEST_GENERATE_SUMMARY_DATA } from '../../constants/analysis/generateSummaryConstants';
import { ActionIcon, Icon } from '../../common';
import { Checkbox, InputText, Radio, TextArea, Switch } from '../../components/form';
//import { REQUEST_SUMMARYDATA } from '../constants/field/GetSummaryDataConstant';
import { REQUEST_SUMMARYDATA, EDIT_SUMMARYDATA } from '../../constants/field/GetSummaryDataConstant';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useInView } from 'react-intersection-observer';
import GreenDropdown from '../../assets/images/green-dropdown.svg';
import { Accordion } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp, FaChevronRight } from 'react-icons/fa';
import spinner from '../../images/tube-spinner3.svg';
import * as XLSX from 'xlsx-js-style';

const SeeButton1 = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  line-height: 1;
  padding: 0 !important;
  padding-top: 2px !important;
  .reverse {
    transform: rotate(-180deg);
  }
`;
const SeeButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  line-height: 1;

  .reverse {
    transform: rotate(-180deg);
  }
`;
const CustomTextArea = styled(TextArea)`
  ::placeholder,
  ::-webkit-input-placeholder,
  ::-moz-placeholder,
  :-ms-input-placeholder {
    color: var(--grey20);
    font-weight: 400;
    font-size: 10px;
  }
  .characters {
    display: none !important;
  }
`;
const CustomButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: var(--midWhite);
  color: var(--sapGreen);
  border-radius: 3px;
  padding: 0.4rem 0.9rem;
  img {
    padding-right: 5px;
  }
  :hover {
    background: var(--midWhite);
    color: ${props => props.buttonColor};
  }

  :disabled,
  [disabled] {
    background: var(--midWhite);
    border: none;
    color: var(--middleGrey);

    :hover {
      background: var(--midWhite);
      border: none;
      color: var(--middleGrey);
      cursor: not-allowed;
    }
  }
`;

const GridContainer = styled.div`
  display: grid;
  gap: 10px;
  grid-auto-rows: minmax(100px, auto);
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  overflow: visible;
`;

const StyledAccordion = styled(Accordion)`
  display: block;
  border: none;
  background-color: transparent;

  .accordion-item {
    border: none;
    background-color: transparent;
  }

  .accordion-header {
    button {
      background-color: transparent;
      border: none;
    white-space: nowrap;
  }
`;

function InlineWrapperWithMargin({ children }) {
  return <span style={{ marginRight: '0.5rem' }}>{children}</span>;
}

const applyCellStyles = worksheet => {
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let R = range.s.r; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellRef];
      if (!cell) continue;

      cell.s = cell.s || {};
      cell.s.alignment = {
        wrapText: true,
        vertical: 'top',
        horizontal: 'left'
      };
      if (R === 0) {
        cell.s.font = {
          bold: true
        };
      }
    }
  }
};

function AnalysisQuestion({
  questionObject,
  question,
  information,
  onCopyClick,
  isSelectAll = true,
  type = 'image',
  handleCopyClick,
  data,
  dataWithoutUrl,
  tag,
  description,
  note,
  qid,
  isMp4 = false,
  filters,
  cTag,
  vType,
  // isSummary,
  preAnalysisData,
  tagsFilterdata = {},
  preSelectedGenerateSummary,
  summaryWithQid,
  isLoadingView,
  isLoadingVideo,
  setIsLoadingView,
  interviewsCompleted,
  isLoadingAudio,
  isHitsOn,
  questionPaperSection_ID,
  subType = ''
}) {
  const [selectedItems, setSelectedItems] = useState(false);
  const [addReport, setAddReport] = useState({});
  const [openClip, setOpenClip] = useState({ id: null, panel: null });

  const toggleClipAccordion = (id, panel) => {
    setOpenClip(prev =>
      prev.id === id && prev.panel === panel ? { id: null, panel: null } : { id, panel }
    );
  };
  const closeClipAccordion = () => setOpenClip({ id: null, panel: null });
  const [selectedGenerateSummary, setSelectedGenerateSummary] = useState([]);
  // setSelectedGenerateSummary([...selectedGenerateSummary, preSelectedGenerateSummary]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const dispatch = useDispatch();
  let { id } = useParams();
  const loggedUser = useSelector(state => state.LoginReducer);
  const [summaryData, setSummaryData] = useState('');
  const [seeMorePrimary, setSeeMorePrimary] = useState();
  // var summaryData = ''
  const summaryData2 = useSelector(state => state.getSummaryReducer.Analysisdata);
  const [summary, setSummary] = useState('');
  const [sliceSummary, setSliceSummary] = useState('');
  const [answers, setAnswers] = useState([]);
  const isLoadingClips = useSelector(state => state.analysisReducer?.isLoadingVideo?.[qid]);

  const [isEditing, setIsEditing] = useState(false); // Define isEditing state
  const [editedSummary, setEditedSummary] = useState(summary);
  const [matchedAnswers, setMatchedAnswers] = useState([]);
  const questionsAnalysisData = useSelector(state => state.analysisReducer?.clipsData?.questionsAnalysisData || {});
  const [isFilterApplied, setIsFilterApplied] = useState(0);
  const projectTitle = useSelector(state => state.ProjectReducer.projectIdentity);
  const withAI = useSelector(state => state.ProjectReducer.resumeData?.project_data?.[0]?.withAI);
  const [sectionName, setSectionName] = useState(null);
  const [clipUpdateStatusSummaryFlag, SetclipUpdateStatusSummaryFlag] = useState(
    questionObject?.ClipUpdateStatusSummaryFlag
  );
  const [mp3UpdateStatusSummaryFlag, SetMP3UpdateStatusSummaryFlag] = useState(
    questionObject?.MP3UpdateSummaryStatusFlag
  );

  const questionData = questionsAnalysisData[qid];
  const getGetProfileData = useSelector(state => state.GetProfileReducer.GetProfileData?.userProfileData[0]);

  function getSectionNameById(data, targetId) {
    const section = data.questionsAnalysisData.find(item => item.questionPaperSection_ID == targetId);
    return section ? section.sectionName : null;
  }

  const checkFilters = data => {
    const scan = val => {
      if (Array.isArray(val)) {
        return val.length > 0;
      }
      if (val && typeof val === 'object') {
        return Object.values(val).some(scan);
      }
      return false;
    };

    return scan(data) ? 1 : 0;
  };

  useEffect(() => {
    if (questionData && questionData.questionsAnalysisData?.length > 0) {
      const extractedAnswers = questionData.questionsAnalysisData
        .flatMap(q => q.questionName_array?.map(qItem => qItem.answer) || [])
        .flat();

      setSectionName(getSectionNameById(questionData, questionPaperSection_ID));

      setAnswers(extractedAnswers);
      setIsFilterLoading(false);
    } else {
      setAnswers([]);
      if (questionData) {
        setIsFilterLoading(false);
      }
    }
  }, [questionData]);

  var isSummary = 0;
  const isGenerated = useSelector(state => state.checkSummaryReducer?.Analysisdata);
  if (isGenerated && isGenerated[qid]) {
    isSummary = isGenerated[qid].isSummary;
  } else {
    isSummary = 0;
  }

  useEffect(() => {
    const normalizedAnswerList = Array.isArray(questionObject.answer)
      ? questionObject.answer
      : questionObject.answer
      ? [questionObject.answer]
      : [];

    const computedAnswers =
      normalizedAnswerList.map(answerItem => {
        const matchingTags =
          questionObject.ansGetChoice
            ?.filter(choice => choice?.mediaAnswerID === answerItem?.questionAnswerImage_ID)
            ?.map(choice => ({ tag_ID: choice?.tag_ID, tagName: choice?.tag, table_ID: choice?.table_ID })) || [];

        const fallbackTags =
          answerItem?.tags?.map(tag => ({
            tag_ID: tag?.tag_ID,
            tagName: tag?.tag || tag?.tagName,
            table_ID: tag?.table_ID
          })) || [];

        return {
          ...answerItem,
          tags: matchingTags.length > 0 ? matchingTags : fallbackTags
        };
      }) || [];

    setMatchedAnswers(computedAnswers);

    SetclipUpdateStatusSummaryFlag(questionObject?.ClipUpdateStatusSummaryFlag);
    SetMP3UpdateStatusSummaryFlag(questionObject?.MP3UpdateSummaryStatusFlag);

    if (type == 'audio') {
      setIsFilterApplied(checkFilters(filters));
    }
  }, [questionObject]);

  const [showAllItems, setShowAllItems] = useState(false);

  const toggleShowAllItems = () => {
    setShowAllItems(!showAllItems);
  };
  const [showMore, setShowMore] = useState(false);
  const currentAudioRef = useRef(null);
  const [currentPlaying, setCurrentPlaying] = useState(null);
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [transcriptButtonColor, setTranscriptButtonColor] = useState('');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5
  });

  const [activeKey, setActiveKey] = useState(null);

  const handlePlay = (index, playerRef) => {
    // Pause the previous video if it's different from the current
    if (currentPlaying !== null && currentPlaying !== playerRef) {
      currentPlaying.load(); // pause the previous video
    }

    setCurrentPlaying(playerRef); // Set the currently playing video ref
  };
  const [itemsToShow, setItemsToShow] = useState(10);
  const [showLess, setShowLess] = useState(false);

  const handleShowAllClick = () => {
    const dataLength = data && data.length ? data.length : 0;
    const answersLength = answers && answers.length ? answers.length : 0;
    const totalLength = Math.max(dataLength, answersLength);

    if (itemsToShow + 10 >= totalLength) {
      setItemsToShow(totalLength);
      setShowLess(true);
    } else {
      setItemsToShow(itemsToShow + 10);
    }
  };

  const handleShowLessClick = () => {
    setItemsToShow(10);
    setShowLess(false);
  };
  const handleAudioPlay = event => {
    if (currentAudioRef.current && currentAudioRef.current !== event.target) {
      currentAudioRef.current.pause();
    }

    currentAudioRef.current = event.target;
  };
  const [showMoreResponses, setShowMoreResponses] = useState(false);

  const toggleShowMoreResponses = () => {
    setShowMoreResponses(!showMoreResponses);
  };
  const SeeLess = () => <>Show Less</>;
  const SeeMore = () => <>Show More</>;

  var mp3Flag = 0;

  const interviewClipsPayload = {
    user_ID: loggedUser.userId,
    clip_ID: isFilterApplied
      ? answers.map(item => {
          return item.projectRepondentVideo_ID;
        })
      : [],
    question_ID: qid,
    questionType_ID: questionObject.questionType_ID
  };

  var mp4ClipsPayload = {
    user_ID: loggedUser.userId,
    clip_ID: isFilterApplied
      ? answers.map(item => {
          return item.questionAnswerImage_ID;
        })
      : [],
    question_ID: qid,
    questionType_ID: questionObject.questionType_ID
  };

  if (subType == 'screener' || type == 'audio') {
    mp4ClipsPayload = {
      user_ID: loggedUser.userId,
      clip_ID: isFilterApplied
        ? data.map(item => {
            return item.questionAnswerImage_ID;
          })
        : [],
      question_ID: qid,
      questionType_ID: questionObject.questionType_ID
    };
  }

  const handleSave = () => {
    dispatch({
      type: EDIT_SUMMARYDATA,
      payload: {
        user_ID: loggedUser.userId,
        project_ID: id,
        question_ID: qid,
        analysis: editedSummary
      }
    });
    setSummary(editedSummary);
    // dispatch({
    //   type: REQUEST_SUMMARYDATA,
    //   payload: {
    //     project_ID: id,
    //     question_ID: qid
    //   }
    // });

    setSeeMorePrimary(false);

    setIsEditing(false);
  };

  if (questionObject?.answer?.length === 1) {
    if (
      questionObject?.answer[0]?.MP3UpdateSummaryStatus == '1' ||
      questionObject?.answer[0]?.MP3UpdateSummaryStatus === null
    ) {
      mp3Flag = 1;
    }
  } else {
    for (var i = 0; i < questionObject?.answer?.length; i++) {
      if (questionObject?.answer[i]?.MP3UpdateSummaryStatus == '1') {
        mp3Flag = 1;
      }
    }
  }

  useEffect(() => {
    if (seeMorePrimary === false) {
      var sliced = summary.slice(0, 250);
      var lastIndex = sliced.lastIndexOf(' ');

      setSliceSummary(sliced.slice(0, lastIndex));
    }

    if (seeMorePrimary === true) {
      setSliceSummary(summary);
    }
  }, [seeMorePrimary]);

  useEffect(() => {
    if (seeMorePrimary === false) {
      var sliced = editedSummary.slice(0, 250);
      var lastIndex = sliced.lastIndexOf(' ');
      setSliceSummary(sliced.slice(0, lastIndex));
    } else {
      setSliceSummary(editedSummary);
    }
  }, [editedSummary]);

  const triggerShowMore = () => {
    setShowMore(!showMore);
    // setShowMore(!showMore)
  };

  var flag = 0;
  for (var i = 0; i < answers?.length; i++) {
    if (answers[i]?.ClipUpdateStatusSummary !== '0' && answers[i]?.ClipUpdateStatusSummary !== null) {
      flag = 1;
    }
  }
  const setSummaryInChild = analysisData => {
    setSummaryData(analysisData);
  };

  const handleCheckbox = index => {
    if (selectedItems.includes(index)) {
      const tempSelectItems = [...selectedItems];
      const filterItems = tempSelectItems.filter(item => item != index);
      setSelectedItems([...filterItems]);
    } else {
      setSelectedItems(prev => [...prev, index]);
    }
  };

  useEffect(() => {
    if (answers && answers.length > 0) {
      setIsFilterLoading(false);

      setIsFilterApplied(checkFilters(filters));
    }
  }, [answers]);

  useEffect(() => {
    if (data && data.length > 0) {
      setIsFilterLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (isFilterLoading) {
      const timer = setTimeout(() => {
        setIsFilterLoading(false);
      }, 5000); // 5 seconds timeout

      return () => clearTimeout(timer);
    }
  }, [isFilterLoading]);

  useEffect(() => {}, [addReport]);

  useEffect(() => {}, [summaryData]);

  useEffect(() => {
    setSelectedGenerateSummary([...selectedGenerateSummary, preSelectedGenerateSummary]);
  }, [preSelectedGenerateSummary]);

  // Reset filter loading when data changes
  useEffect(() => {
    if (answers && answers.length > 0) {
      setIsFilterLoading(false);
    }
  }, [answers]);

  useEffect(() => {
    if (data && data.length > 0) {
      setIsFilterLoading(false);
    }
  }, [data]);

  // Reset filter loading after a timeout to prevent infinite skeleton
  useEffect(() => {
    if (isFilterLoading) {
      const timer = setTimeout(() => {
        setIsFilterLoading(false);
      }, 5000); // 5 seconds timeout

      return () => clearTimeout(timer);
    }
  }, [isFilterLoading]);

  useEffect(() => {
    if (type !== 'image' || activeKey !== '0') return;

    setIsFilterLoading(true);
    dispatch({
      type: REQUEST_ANALYSIS_CLIPS_DATA,
      payload: {
        project_ID: id,
        AgeGroup: filters?.AgeGroup,
        MaritalStatus: filters?.MaritalStatus,
        Gender: filters?.Gender,
        classificationData: filters?.classificationData,
        UserType: filters?.UserType,
        Geography: filters?.Geography,
        Ownership: filters?.Ownership,
        CustomTags: filters?.CustomTags ?? null,
        CustomTags1: filters?.CustomTags ?? null,
        question_ID: qid
      }
    });
  }, [filters]);

  const getClipsTagsByImageId = (Array.isArray(answers) ? answers : []).reduce((map, answer) => {
    const imageId = answer?.questionAnswerImage_ID;
    const tags = answer?.tags;
    if (imageId != null && Array.isArray(tags) && tags.length > 0) {
      map.set(String(imageId), tags);
    }
    return map;
  }, new Map());

  const withGetClipsTags = item => {
    const clipTags =
      item?.questionAnswerImage_ID != null
        ? getClipsTagsByImageId.get(String(item.questionAnswerImage_ID))
        : null;
    if (!clipTags) return item;
    return { ...item, tags: clipTags };
  };

  const addTagForClipItem = (item, index) => {
    const matched = matchedAnswers[index];
    const hasClipTags =
      item?.questionAnswerImage_ID != null && getClipsTagsByImageId.has(String(item.questionAnswerImage_ID));
    if (!hasClipTags || !matched) return matched;
    return { ...matched, tags: [] };
  };

  const analysisMedia = Array.isArray(data) ? data : data ? [data] : [];
  const mediaByImageId = analysisMedia.reduce((map, item) => {
    if (item?.questionAnswerImage_ID != null) {
      map.set(String(item.questionAnswerImage_ID), item);
    }
    return map;
  }, new Map());
  const matchedByImageId = (Array.isArray(matchedAnswers) ? matchedAnswers : []).reduce((map, answer) => {
    if (answer?.questionAnswerImage_ID != null) {
      map.set(String(answer.questionAnswerImage_ID), answer);
    }
    return map;
  }, new Map());

  const addTagForImageItem = item => {
    const matched = matchedByImageId.get(String(item?.questionAnswerImage_ID));
    const hasClipTags =
      item?.questionAnswerImage_ID != null && getClipsTagsByImageId.has(String(item.questionAnswerImage_ID));
    if (!hasClipTags || !matched) return matched;
    return { ...matched, tags: [] };
  };

  const imageItems = questionData
    ? (Array.isArray(answers) ? answers : []).map(answer => {
        const media = mediaByImageId.get(String(answer?.questionAnswerImage_ID)) || {};
        const clipTags = Array.isArray(answer?.tags) && answer.tags.length > 0 ? answer.tags : null;
        return {
          ...media,
          ...answer,
          preAssingedImageUrl: media.preAssingedImageUrl || answer?.preAssingedImageUrl,
          maskedName: answer?.maskedName || media.maskedName,
          tags: clipTags || media.tags || []
        };
      })
    : analysisMedia.map(withGetClipsTags);

  const normalizedMp4Data = Array.isArray(data) ? data : data ? [data] : [];
  const mp4WithClipTags = normalizedMp4Data.map(withGetClipsTags);
  const videoAnswers = isMp4 ? (mp4WithClipTags.length > 0 ? mp4WithClipTags : answers) : answers;

  return (
    <div className=" question" style={{ borderBottom: '1px solid var(--greyBlue30)' }} ref={ref}>
      {inView ? (
        <StyledAccordion>
          <Accordion.Item eventKey="0">
            <div className="d-flex justify-content-between my-2" style={{ alignItems: 'center', gap: '10px' }}>
              <Accordion.Header style={{ flex: '1 1 auto', minWidth: '60%' }}>
                <Heading
                  fontSize="14px"
                  fontWeight="700"
                  color="var(--deepBlue)"
                  className="mb-0 pb-0"
                  breakHeading={false}
                  style={{
                    justifyContent: 'space-between',
                    whiteSpace: 'normal',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                  }}
                  // onClick={() => setActiveKey(activeKey === '0' ? null : '0')}
                  onClick={() => {
                    const isCurrentlyOpen = activeKey === '0'; // check if it's currently open
                    const newKey = isCurrentlyOpen ? null : '0'; // toggle

                    setActiveKey(newKey);

                    if (!isCurrentlyOpen) {
                      // Accordion is opening
                      setIsFilterLoading(true);

                      dispatch({
                        type: REQUEST_ANALYSIS_CLIPS_DATA,
                        payload: {
                          project_ID: id,
                          AgeGroup: filters?.AgeGroup,
                          MaritalStatus: filters?.MaritalStatus,
                          Gender: filters?.Gender,
                          classificationData: filters?.classificationData,
                          UserType: filters?.UserType,
                          Geography: filters?.Geography,
                          Ownership: filters?.Ownership,
                          CustomTags: filters?.CustomTags ?? null,
                          CustomTags1: filters?.CustomTags ?? null,
                          question_ID: qid
                        }
                      });
                    } else {
                      // Accordion is closing
                      setIsFilterLoading(false);
                    }
                  }}
                >
                  {question}
                  {activeKey === '0' ? (
                    <FaChevronDown size={10} style={{ marginLeft: '8px' }} />
                  ) : (
                    <FaChevronRight size={10} style={{ marginLeft: '8px' }} />
                  )}
                  <span>
                    {type === 'video' && isMp4 == false && (
                      <Heading fontSize="12px" fontWeight="400" color="var(--deepBlue)" className="mb-0 pb-0 pl-1">
                        {questionObject?.answerCount + ' Videos'}
                      </Heading>
                    )}

                    {type === 'video' && isMp4 == true && (
                      <Heading fontSize="12px" fontWeight="400" color="var(--deepBlue)" className="mb-0 pb-0 pl-1">
                        {data?.length + ' Videos'}
                      </Heading>
                    )}

                    {information && type === 'audio' && (
                      <Heading fontSize="12px" fontWeight="400" color="var(--deepBlue)" className="mb-0 pb-0 pl-1">
                        {data?.length + ' Audios'}
                      </Heading>
                    )}
                    {information && type === 'image' && (
                      <Heading fontSize="12px" fontWeight="400" color="var(--deepBlue)" className="mb-0 pb-0 pl-1">
                        {information}
                      </Heading>
                    )}
                    {/* {information && vType && vType.length === 0 && (
                      <Heading fontSize="12px" fontWeight="400" color="var(--deepBlue)" className="mb-0 pb-0 pl-1">
                        {information}
                      </Heading>
                    )} */}
                  </span>
                </Heading>
              </Accordion.Header>

              {activeKey === '0' ? (
                <div style={{ flex: '0 1 auto', width: '30%', marginTop: '10px' }}>
                  {questionObject?.answerCount &&
                  questionObject?.answerCount > 0 &&
                  type == 'video' &&
                  isMp4 == false &&
                  information.split('')[0] !== '0' &&
                  isLoadingClips == false ? (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                      }}
                    >
                      {(withAI === 1 || withAI === '1') && (
                        <SummaryTextContainer
                          type={'video'}
                          interviewsCompleted={interviewsCompleted}
                          isLoading={isLoading}
                          summary={summary}
                          isMp4={false}
                          setIsLoadingView={setIsLoadingView}
                          isLoadingVideo={isLoadingVideo}
                          question_ID={qid}
                          id={answers[answers?.length - 1]?.projectRepondentVideo_ID}
                          project_id={id}
                          setSelectedGenerateSummary={setSelectedGenerateSummary}
                          preSelectedGenerateSummary={preSelectedGenerateSummary}
                          selectedGenerateSummary={selectedGenerateSummary}
                          setIsLoading={setIsLoading}
                          flag={questionObject.ClipUpdateStatusSummaryFlag}
                          isSummary={isSummary}
                          setSummary={setSummary}
                          setSliceSummary={setSliceSummary}
                          isFilterApplied={isFilterApplied}
                          answers={answers}
                          SetclipUpdateStatusSummaryFlag={SetclipUpdateStatusSummaryFlag}
                          SetMP3UpdateStatusSummaryFlag={SetMP3UpdateStatusSummaryFlag}
                          filters={filters}
                          subType={subType}
                          data={data}
                        />
                      )}
                      {clipUpdateStatusSummaryFlag == 0 && (withAI === 1 || withAI === '1') ? (
                        <Button
                          size="small"
                          width="50px"
                          buttonColor={transcriptButtonColor}
                          onClick={() => {
                            setTranscriptLoading(true);
                            setTranscriptButtonColor('#F2F4F4');
                            maverickPortalhttp
                              .makeRequest(
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.url,
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.methodType,
                                interviewClipsPayload
                              )
                              .then(response => {
                                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                                return response.data; // ✅ Already JSON
                              })
                              .then(result => {
                                var transcriptData;
                                var headers;

                                if(getGetProfileData.isGlobalAccess == 1){
                                   transcriptData = result?.Response?.Transcript?.[0]?.[0]?.Transcript || [];
                                   headers = ['Questions', 'Respondent Name', 'Name' , 'Transcript'];

                                }
                                else{
                                   transcriptData = result?.Response?.Transcript?.[0]?.[0]?.Transcript || [];
                                   transcriptData = transcriptData.map(row => row.filter((_, index) => index !== 2));
                                   headers = ['Questions', 'Name', 'Transcript'];
                                }
                                

                                // Handle empty data gracefully
                                if (!transcriptData.length) {
                                  console.warn('No transcript data found for this question.');
                                  setTranscriptLoading(false);
                                  setTranscriptButtonColor('#C0392B');
                                  return;
                                }

                                const dataForExcel = [headers, ...transcriptData];

                                const worksheet = XLSX.utils.aoa_to_sheet(dataForExcel);
                                worksheet['!cols'] = [{ wch: 40 }, { wch: 25 }, { wch: 60 }];
                                applyCellStyles(worksheet);

                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Transcript');
                                XLSX.writeFile(
                                  workbook,
                                  `${projectTitle}_${sectionName}_${question.split(' ')[0]}.xlsx`
                                );

                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#9EBE21');
                              })
                              .catch(error => {
                                console.error('Error fetching transcript:', error);
                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#C0392B');
                              });
                          }}
                        >
                          Download Transcript
                          {transcriptLoading ? (
                            <img
                              src={spinner}
                              style={{
                                width: '20px',
                                transform: 'scale(1,-1)',
                                marginLeft: '0.3rem',
                                paddingRight: '0px'
                              }}
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ' '
                  )}

                  {type == 'video' && isMp4 == true && information.split('')[0] !== '0' && isLoadingVideo == false ? (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                      }}
                    >
                      {(withAI === 1 || withAI === '1') && (
                        <SummaryTextContainer
                          type={'video'}
                          mp3Flag={questionObject.ClipUpdateStatusSummaryFlag}
                          interviewsCompleted={interviewsCompleted}
                          isLoading={isLoading}
                          summary={summary}
                          isMp4={true}
                          setIsLoadingView={setIsLoadingView}
                          isLoadingVideo={isLoadingVideo}
                          question_ID={qid}
                          id={data ? data[data?.length - 1]?.projectRepondentVideo_ID : 0}
                          project_id={id}
                          setSelectedGenerateSummary={setSelectedGenerateSummary}
                          preSelectedGenerateSummary={preSelectedGenerateSummary}
                          selectedGenerateSummary={selectedGenerateSummary}
                          setIsLoading={setIsLoading}
                          flag={flag}
                          isSummary={isSummary}
                          setSummary={setSummary}
                          setSliceSummary={setSliceSummary}
                          isFilterApplied={isFilterApplied}
                          answers={answers}
                          SetclipUpdateStatusSummaryFlag={SetclipUpdateStatusSummaryFlag}
                          SetMP3UpdateStatusSummaryFlag={SetMP3UpdateStatusSummaryFlag}
                          filters={filters}
                          subType={subType}
                          data={data}
                        />
                      )}
                      {clipUpdateStatusSummaryFlag == 0 && (withAI === 1 || withAI === '1') ? (
                        <Button
                          size="small"
                          width="50px"
                          buttonColor={transcriptButtonColor}
                          onClick={() => {
                            setTranscriptLoading(true);
                            setTranscriptButtonColor('#F2F4F4');
                            maverickPortalhttp
                              .makeRequest(
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.url,
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.methodType,
                                mp4ClipsPayload
                              )
                              .then(response => {
                                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                                return response.data; // ✅ Already JSON
                              })
                              .then(result => {
                                const transcriptData = result?.Response?.Transcript?.[0]?.[0]?.Transcript || [];
                                const headers = ['Questions', 'Name', 'Transcript'];

                                // Handle empty data gracefully
                                if (!transcriptData.length) {
                                  console.warn('No transcript data found for this question.');
                                  setTranscriptLoading(false);
                                  setTranscriptButtonColor('#C0392B');
                                  return;
                                }

                                const dataForExcel = [headers, ...transcriptData];

                                const worksheet = XLSX.utils.aoa_to_sheet(dataForExcel);
                                worksheet['!cols'] = [{ wch: 40 }, { wch: 25 }, { wch: 60 }];
                                applyCellStyles(worksheet);

                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Transcript');
                                XLSX.writeFile(
                                  workbook,
                                  `${projectTitle}_${sectionName}_${question.split(' ')[0]}.xlsx`
                                );

                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#9EBE21');
                              })
                              .catch(error => {
                                console.error('Error fetching transcript:', error);
                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#C0392B');
                              });
                          }}
                        >
                          Download Transcript
                          {transcriptLoading ? (
                            <img
                              src={spinner}
                              style={{
                                width: '20px',
                                transform: 'scale(1,-1)',
                                marginLeft: '0.3rem',
                                paddingRight: '0px'
                              }}
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ' '
                  )}

                  {type == 'audio' && information.split('')[0] !== '0' && isLoadingAudio == false ? (
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                      }}
                    >
                      {(withAI === 1 || withAI === '1') && (
                        <SummaryTextContainer
                          type={'audio'}
                          mp3Flag={questionObject.MP3UpdateSummaryStatusFlag}
                          interviewsCompleted={interviewsCompleted}
                          isLoading={isLoading}
                          summary={summary}
                          isMp4={false}
                          setIsLoadingView={setIsLoadingView}
                          isLoadingVideo={isLoadingVideo}
                          question_ID={qid}
                          id={data ? data[data?.length - 1]?.projectRepondentVideo_ID : 0}
                          project_id={id}
                          setSelectedGenerateSummary={setSelectedGenerateSummary}
                          preSelectedGenerateSummary={preSelectedGenerateSummary}
                          selectedGenerateSummary={selectedGenerateSummary}
                          setIsLoading={setIsLoading}
                          flag={flag}
                          isSummary={isSummary}
                          setSummary={setSummary}
                          setSliceSummary={setSliceSummary}
                          isFilterApplied={isFilterApplied}
                          answers={answers}
                          SetclipUpdateStatusSummaryFlag={SetclipUpdateStatusSummaryFlag}
                          SetMP3UpdateStatusSummaryFlag={SetMP3UpdateStatusSummaryFlag}
                          filters={filters}
                          subType={subType}
                          data={data}
                        />
                      )}
                      {mp3UpdateStatusSummaryFlag == 0 && (withAI === 1 || withAI === '1') ? (
                        <Button
                          size="small"
                          width="50px"
                          buttonColor={transcriptButtonColor}
                          onClick={() => {
                            setTranscriptLoading(true);
                            setTranscriptButtonColor('#F2F4F4');
                            maverickPortalhttp
                              .makeRequest(
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.url,
                                maverickPortalApiEndPoint.getQuestiontranscriptCSV.methodType,
                                mp4ClipsPayload
                              )
                              .then(response => {
                                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                                return response.data; // ✅ Already JSON
                              })
                              .then(result => {
                                const transcriptData = result?.Response?.Transcript?.[0]?.[0]?.Transcript || [];
                                const headers = ['Questions', 'Name', 'Transcript'];

                                // Handle empty data gracefully
                                if (!transcriptData.length) {
                                  console.warn('No transcript data found for this question.');
                                  setTranscriptLoading(false);
                                  setTranscriptButtonColor('#C0392B');
                                  return;
                                }

                                const dataForExcel = [headers, ...transcriptData];

                                const worksheet = XLSX.utils.aoa_to_sheet(dataForExcel);
                                worksheet['!cols'] = [{ wch: 40 }, { wch: 25 }, { wch: 60 }];
                                applyCellStyles(worksheet);

                                const workbook = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(workbook, worksheet, 'Transcript');
                                XLSX.writeFile(
                                  workbook,
                                  `${projectTitle}_${sectionName}_${question.split(' ')[0]}.xlsx`
                                );

                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#9EBE21');
                              })
                              .catch(error => {
                                console.error('Error fetching transcript:', error);
                                setTranscriptLoading(false);
                                setTranscriptButtonColor('#C0392B');
                              });
                          }}
                        >
                          Download Transcript
                          {transcriptLoading ? (
                            <img
                              src={spinner}
                              style={{
                                width: '20px',
                                transform: 'scale(1,-1)',
                                marginLeft: '0.3rem',
                                paddingRight: '0px'
                              }}
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ' '
                  )}
                </div>
              ) : (
                ''
              )}

              <div className="d-flex align-items-center" style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>
                {selectedItems == false ? (
                  <CustomButton
                    fontWeight="400"
                    fontSize="10px"
                    className="ml-0"
                    size="small"
                    variant="outlined"
                    buttonColor="var(--sapGreen)"
                    disabled={true}
                    onClick={() => handleCopyClick(qid, addReport, question, questionObject)}
                  >
                    {true ? <img src={copy} /> : <img src={copy_active} />} Copy to Report
                  </CustomButton>
                ) : (
                  <CustomButton
                    fontWeight="400"
                    fontSize="10px"
                    className="ml-2"
                    size="small"
                    variant="outlined"
                    buttonColor="var(--sapGreen)"
                    disabled={false}
                    onClick={() => handleCopyClick(qid, addReport, question, questionObject)}
                  >
                    {false ? <img src={copy} /> : <img src={copy_active} />} Copy to Report
                  </CustomButton>
                )}
              </div>
            </div>

            <Accordion.Body>
              {isLoading === false && summary && selectedGenerateSummary.includes(qid) ? (
                <div>
                  <Heading
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily="Noto Sans"
                    fontStyle="normal"
                    lineHeight="normal"
                    color="#38454F"
                    className="mb-0 pb-2 mt-2"
                  >
                    <b>Summary</b>
                  </Heading>

                  <div
                    style={{
                      background: 'rgb(242, 244, 244)',
                      marginBottom: '2%',
                      padding: '1%',
                      marginTop: '1 %',
                      borderRadius: '5px'
                    }}
                  >
                    {isEditing ? ( // Conditionally render textarea for editing
                      <>
                        <CustomTextArea
                          value={editedSummary}
                          onChange={e => setEditedSummary(e.target.value)}
                          rows={4}
                          showCharacters={false}
                          characterLimit={524288}
                          cols={50}
                        />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Icon onClick={handleSave} style={{ cursor: 'pointer' }}>
                            save
                          </Icon>
                        </div>
                      </>
                    ) : (
                      <>
                        {(() => {
                          try {
                            const parsed = JSON.parse(summary);
                            let sliced_parsed;
                            if (parsed.length > 2) {
                              sliced_parsed = parsed.slice(0, 2);
                            }

                            if (Array.isArray(parsed)) {
                              return summary.length > 250 && !seeMorePrimary
                                ? sliced_parsed.map((item, index) => (
                                    <div key={index}>
                                      {index + 1}. {item}
                                    </div>
                                  ))
                                : parsed.map((item, index) => (
                                    <div key={index}>
                                      {index + 1}. {item}
                                    </div>
                                  ));
                            } else {
                              return summary.length > 250 ? sliceSummary : summary;
                            }
                          } catch (err) {
                            // If it's not valid JSON, fall back to raw summary

                            return summary.length > 250 ? sliceSummary : summary;
                          }
                        })()}

                        {summary.length > 250 ? (
                          <SeeButton
                            style={{ display: 'inline-block' }}
                            className="mt-0"
                            simple
                            color="var(--primaryColor)"
                            fontSize="0.875rem"
                            fontWeight="500"
                            onClick={() => setSeeMorePrimary(!seeMorePrimary)}
                          >
                            {seeMorePrimary ? SeeLess() : SeeMore()}
                          </SeeButton>
                        ) : (
                          ''
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <ActionIcon
                            onClick={() => {
                              setIsEditing(true);
                              setEditedSummary(summary);
                            }}
                          >
                            create
                          </ActionIcon>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}

              {type === 'audio' && isLoadingAudio !== false ? (
                <Skeleton count={5} wrapper={InlineWrapperWithMargin} inline width={220} height={70} />
              ) : type == 'video' && isLoadingVideo !== false ? (
                <Skeleton count={5} wrapper={InlineWrapperWithMargin} inline width={220} height={70} />
              ) : type == 'image' && isLoadingView !== false ? (
                <Skeleton count={5} wrapper={InlineWrapperWithMargin} inline width={220} height={70} />
              ) : (
                <GridContainer>
                  {isLoadingClips || (type === 'video' && isLoadingVideo !== false) || isFilterLoading ? (
                    <div style={{ marginBottom: '1.5rem', width: '1200px' }}>
                      <Skeleton count={4} wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                    </div>
                  ) : (type === 'image'
                      ? imageItems.length > 0
                      : (answers && answers?.length > 0) || (data && data?.length > 0)) ? (
                    <>
                      {type === 'video'
                        ? videoAnswers?.slice(0, itemsToShow).map((item, index) => {
                            let tagH = [];
                            item?.tags?.map(a => {
                              if (a.tag === 'Hits') {
                                tagH.push('Hits');
                              }
                              if (a.tag === 'Misses') {
                                tagH.push('Misses');
                              }
                            });

                            if (!cTag && isLoadingVideo == false && isMp4 == true && vType.length == 0) {
                              return (
                                <AnalysisVideo
                                  questionType_ID={questionObject.questionType_ID}
                                  clipDetails={item}
                                  clipWithoutUrl={videoAnswers?.[index] || {}}
                                  addtag={addTagForClipItem(item, index)}
                                  tag={item?.tags}
                                  description={description}
                                  note={item?.VideoNote}
                                  imgLink={item?.preAssingedImageUrl}
                                  // thumbLink={item.preAssingedImageUrl}
                                  thumbLink={item?.mp4ThumbnailFilePath}
                                  dataLength={videoAnswers.length}
                                  filters={filters}
                                  tagsFilterdata={tagsFilterdata}
                                  ref={el => (videoRefs.current[index] = el)}
                                  // isPlaying={playingVideo == index}
                                  onPlay={playerRef => handlePlay(index, playerRef)}
                                  keepCheckBox={true}
                                  checkBoxValue={item?.videoPresignedUrl}
                                  selectCheckBox={val => {
                                    let d = addReport;
                                    if (d.hasOwnProperty(val.vidId.toString())) {
                                      delete d[val.vidId.toString()];
                                      if (Object.keys(d).length == 0) {
                                        setSelectedItems(false);
                                      }
                                    } else {
                                      if (Object.keys(addReport).length >= 8) {
                                        console.log('Maximum 8 Videos can be exported.');
                                        return;
                                      }
                                      (d[val.vidId.toString()] = val), setSelectedItems(true);
                                    }

                                    setAddReport({ ...d });
                                  }}
                                  name={item?.maskedName}
                                  button={item?.buttonName}
                                  vidId={item?.questionAnswerImage_ID}
                                  openPanel={openClip.id === item?.questionAnswerImage_ID ? openClip.panel : null}
                                  onToggleAccordion={panel => toggleClipAccordion(item?.questionAnswerImage_ID, panel)}
                                  onCloseAccordion={closeClipAccordion}
                                  qid={qid}
                                  selection={addReport}
                                  clipUpdateStatus={item?.MP3UpdateSummaryStatus}
                                  Skeleton={
                                    <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                  }
                                />
                              );
                            }

                            if (!cTag && isLoadingVideo == false && isMp4 == false && vType.length == 0) {
                              return (
                                <AnalysisVideo
                                  questionType_ID={questionObject.questionType_ID}
                                  clipDetails={item}
                                  clipWithoutUrl={videoAnswers?.[index] || {}}
                                  addtag={isMp4 ? addTagForClipItem(item, index) : matchedAnswers[index]}
                                  tag={item?.tags}
                                  description={description}
                                  note={item.VideoNote}
                                  imgLink={item.videoPresignedUrl}
                                  thumbLink={item.thumbnailPresignedUrl}
                                  filters={filters}
                                  tagsFilterdata={tagsFilterdata}
                                  ref={el => (videoRefs.current[index] = el)}
                                  // isPlaying={playingVideo == index}
                                  onPlay={playerRef => handlePlay(index, playerRef)}
                                  checkBoxValue={item.videoPresignedUrl}
                                  dataLength={videoAnswers.length}
                                  selectCheckBox={val => {
                                    let d = addReport;

                                    if (d.hasOwnProperty(val.vidId.toString())) {
                                      delete d[val.vidId.toString()];
                                      if (Object.keys(d).length == 0) {
                                        setSelectedItems(false);
                                      }
                                    } else {
                                      (d[val.vidId.toString()] = val), setSelectedItems(true);
                                    }

                                    setAddReport({ ...d });
                                  }}
                                  name={item.maskedName}
                                  button={item.buttonName}
                                  vidId={item.projectRepondentVideo_ID}
                                  openPanel={openClip.id === item.projectRepondentVideo_ID ? openClip.panel : null}
                                  onToggleAccordion={panel => toggleClipAccordion(item.projectRepondentVideo_ID, panel)}
                                  onCloseAccordion={closeClipAccordion}
                                  qid={qid}
                                  selection={addReport}
                                  clipUpdateStatus={item.ClipUpdateStatus}
                                  Skeleton={
                                    <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                  }
                                />
                              );
                            }

                            if (cTag && isLoadingVideo == false && vType.length == 0) {
                              if (item?.tags?.indexOf(cTag) != -1) {
                                return (
                                  <AnalysisVideo
                                    questionType_ID={questionObject.questionType_ID}
                                    clipDetails={item}
                                    clipWithoutUrl={videoAnswers?.[index] || {}}
                                    addtag={isMp4 ? addTagForClipItem(item, index) : matchedAnswers[index]}
                                    tag={item?.tags}
                                    description={description}
                                    // hoverList={item.tags}
                                    note={item?.VideoNote}
                                    imgLink={item.videoPresignedUrl}
                                    filters={filters}
                                    thumbLink={item.thumbnailPresignedUrl}
                                    tagsFilterdata={tagsFilterdata}
                                    ref={el => (videoRefs.current[index] = el)}
                                    // isPlaying={playingVideo == index}
                                    onPlay={playerRef => handlePlay(index, playerRef)}
                                    checkBoxValue={item.videoPresignedUrl}
                                    dataLength={videoAnswers.length}
                                    selectCheckBox={val => {
                                      let d = addReport;
                                      if (d.hasOwnProperty(val.vidId.toString())) {
                                        delete d[val.vidId.toString()];
                                        if (Object.keys(d).length == 0) {
                                          setSelectedItems(false);
                                        }
                                      } else {
                                        (d[val.vidId.toString()] = val), setSelectedItems(true);
                                      }

                                      setAddReport({ ...d });
                                    }}
                                    name={item.maskedName}
                                    button={item.buttonName}
                                    vidId={item.projectRepondentVideo_ID}
                                    openPanel={openClip.id === item.projectRepondentVideo_ID ? openClip.panel : null}
                                    onToggleAccordion={panel => toggleClipAccordion(item.projectRepondentVideo_ID, panel)}
                                    onCloseAccordion={closeClipAccordion}
                                    qid={qid}
                                    selection={addReport}
                                    Skeleton={
                                      <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                    }
                                  />
                                );
                              }
                            }

                            if (!cTag && isLoadingVideo == false && vType.length > 0) {
                              if (vType.indexOf(item.buttonName) != -1 || tagH.some(val => vType.includes(val))) {
                                return (
                                  <AnalysisVideo
                                    questionType_ID={questionObject.questionType_ID}
                                    clipDetails={item}
                                    clipWithoutUrl={videoAnswers?.[index] || {}}
                                    addtag={isMp4 ? addTagForClipItem(item, index) : matchedAnswers[index]}
                                    tag={item?.tags}
                                    description={description}
                                    note={item?.VideoNote}
                                    imgLink={item.videoPresignedUrl}
                                    filters={filters}
                                    thumbLink={item.thumbnailPresignedUrl}
                                    tagsFilterdata={tagsFilterdata}
                                    ref={el => (videoRefs.current[index] = el)}
                                    // isPlaying={playingVideo == index}
                                    onPlay={playerRef => handlePlay(index, playerRef)}
                                    dataLength={videoAnswers.length}
                                    checkBoxValue={item.videoPresignedUrl}
                                    selectCheckBox={val => {
                                      let d = addReport;
                                      if (d.hasOwnProperty(val.vidId.toString())) {
                                        delete d[val.vidId.toString()];
                                        if (Object.keys(d).length == 0) {
                                          setSelectedItems(false);
                                        }
                                      } else {
                                        (d[val.vidId.toString()] = val), setSelectedItems(true);
                                      }

                                      setAddReport({ ...d });
                                    }}
                                    name={item.maskedName}
                                    button={item.buttonName}
                                    vidId={item.projectRepondentVideo_ID}
                                    openPanel={openClip.id === item.projectRepondentVideo_ID ? openClip.panel : null}
                                    onToggleAccordion={panel => toggleClipAccordion(item.projectRepondentVideo_ID, panel)}
                                    onCloseAccordion={closeClipAccordion}
                                    qid={qid}
                                    selection={addReport}
                                    Skeleton={
                                      <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                    }
                                  />
                                );
                              }
                            }

                            if (cTag && isLoadingVideo == false && vType.length > 0) {
                              if (item.tags.indexOf(cTag) != -1 && vType.indexOf(item.buttonName) != -1) {
                                return (
                                  <AnalysisVideo
                                    questionType_ID={questionObject.questionType_ID}
                                    clipDetails={item}
                                    clipWithoutUrl={videoAnswers?.[index] || {}}
                                    addtag={isMp4 ? addTagForClipItem(item, index) : matchedAnswers[index]}
                                    tag={item?.tags}
                                    description={description}
                                    note={item?.VideoNote}
                                    imgLink={item.videoPresignedUrl}
                                    filters={filters}
                                    thumbLink={item.thumbnailPresignedUrl}
                                    tagsFilterdata={tagsFilterdata}
                                    ref={el => (videoRefs.current[index] = el)}
                                    // isPlaying={playingVideo == index}
                                    onPlay={playerRef => handlePlay(index, playerRef)}
                                    dataLength={videoAnswers.length}
                                    checkBoxValue={item.videoPresignedUrl}
                                    selectCheckBox={val => {
                                      let d = addReport;
                                      if (d.hasOwnProperty(val.vidId.toString())) {
                                        delete d[val.vidId.toString()];
                                        if (Object.keys(d).length == 0) {
                                          setSelectedItems(false);
                                        }
                                      } else {
                                        (d[val.vidId.toString()] = val), setSelectedItems(true);
                                      }

                                      setAddReport({ ...d });
                                    }}
                                    name={item.maskedName}
                                    button={item.buttonName}
                                    vidId={item.projectRepondentVideo_ID}
                                    openPanel={openClip.id === item.projectRepondentVideo_ID ? openClip.panel : null}
                                    onToggleAccordion={panel => toggleClipAccordion(item.projectRepondentVideo_ID, panel)}
                                    onCloseAccordion={closeClipAccordion}
                                    qid={qid}
                                    selection={addReport}
                                    Skeleton={
                                      <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                    }
                                  />
                                );
                              }
                            }
                          })
                        : type === 'image'
                          ? imageItems.slice(0, itemsToShow).map((item, index) => {
                            return (
                              <AnalysisImage
                                key={item.questionAnswerImage_ID || index}
                                imgLink={item.preAssingedImageUrl}
                                checkBoxValue={item.preAssingedImageUrl}
                                selectCheckBox={val => {
                                  let d = addReport;
                                  if (d.hasOwnProperty(val.imgId.toString())) {
                                    delete d[val.imgId.toString()];
                                    if (Object.keys(d).length == 0) {
                                      setSelectedItems(false);
                                    }
                                  } else {
                                    if (Object.keys(addReport).length >= 8) {
                                      console.log('Maximum 8 photos can be exported.');
                                      return;
                                    }
                                    (d[val.imgId.toString()] = val), setSelectedItems(true);
                                  }

                                  setAddReport({ ...d });
                                }}
                                name={item.maskedName}
                                imgId={item.questionAnswerImage_ID}
                                openPanel={openClip.id === item.questionAnswerImage_ID ? openClip.panel : null}
                                onToggleAccordion={panel => toggleClipAccordion(item.questionAnswerImage_ID, panel)}
                                onCloseAccordion={closeClipAccordion}
                                questionType_ID={questionObject.questionType_ID}
                                filters={filters}
                                tagsFilterdata={tagsFilterdata}
                                clipWithoutUrl={item}
                                addtag={addTagForImageItem(item)}
                                qid={qid}
                                selection={addReport}
                                Skeleton={
                                  <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                }
                              />
                            );
                          })
                        : data.slice(0, itemsToShow).map((item, index) => {
                            if (isLoadingAudio === false && type === 'audio') {
                              return (
                                <AnalysisAudio
                                  key={index}
                                  imgLink={item.preAssingedImageUrl}
                                  checkBoxValue={item.preAssingedImageUrl}
                                  onPlay={handleAudioPlay}
                                  selectCheckBox={val => {
                                    let d = addReport;

                                    if (d.hasOwnProperty(val.imgId.toString())) {
                                      delete d[val.imgId.toString()];
                                      if (Object.keys(d).length == 0) {
                                        setSelectedItems(false);
                                      }
                                    } else {
                                      if (Object.keys(addReport).length >= 8) {
                                        console.log('Maximum 8 Audios can be exported.');
                                        return;
                                      }
                                      (d[val.imgId.toString()] = val), setSelectedItems(true);
                                    }

                                    setAddReport({ ...d });
                                  }}
                                  name={item.maskedName}
                                  imgId={item.questionAnswerImage_ID}
                                  openPanel={openClip.id === item.questionAnswerImage_ID ? openClip.panel : null}
                                  onToggleAccordion={panel => toggleClipAccordion(item.questionAnswerImage_ID, panel)}
                                  onCloseAccordion={closeClipAccordion}
                                  qid={qid}
                                  questionType_ID={questionObject.questionType_ID}
                                  filters={filters}
                                  tagsFilterdata={tagsFilterdata}
                                  clipWithoutUrl={item}
                                  addtag={matchedAnswers[index]}
                                  selection={addReport}
                                  Skeleton={
                                    <Skeleton wrapper={InlineWrapperWithMargin} inline width={220} height={140} />
                                  }
                                />
                              );
                            }
                          })}
                    </>
                  ) : type === 'audio' && isLoadingAudio === false && !isFilterLoading ? (
                    <p>No Audios available</p>
                  ) : type === 'video' && isLoadingVideo === false && isLoadingClips === false && !isFilterLoading ? (
                    <p>No Videos available</p>
                  ) : type === 'image' && isLoadingView === false && !isFilterLoading ? (
                    <p>No Photos available</p>
                  ) : (
                    <p>No data available</p>
                  )}
                </GridContainer>
              )}

              <center>
                {' '}
                <br />{' '}
                <div style={{ marginLeft: '50%' }}>
                  {(type === 'image'
                    ? imageItems.length > 10
                    : (data && data.length > 10) || (answers && answers.length > 10)) && !showLess && (
                    <SeeButton1
                      className="mb-0 pb-0 ml-2"
                      simple
                      color="var(--primaryColor)"
                      fontSize="0.750rem"
                      fontWeight="500"
                      onClick={handleShowAllClick}
                    >
                      See more <img src={GreenDropdown} className="ml-2 reverse" />
                    </SeeButton1>
                  )}
                  {showLess && (
                    <SeeButton1
                      className="mb-0 pb-0 ml-2"
                      simple
                      color="var(--primaryColor)"
                      fontSize="0.750rem"
                      fontWeight="500"
                      onClick={handleShowLessClick}
                    >
                      See Less <img src={GreenDropdown} className="ml-2" />
                    </SeeButton1>
                  )}
                </div>
              </center>
            </Accordion.Body>
          </Accordion.Item>
        </StyledAccordion>
      ) : (
        <div>
          <div style={{ marginBottom: '1.5rem' }}>
            <Skeleton height={30} width="60%" style={{ marginBottom: '0.5rem' }} />
            <Skeleton count={3} height={20} width="100%" style={{ marginBottom: '0.5rem' }} />
          </div>
        </div>
      )}
    </div>
  );
}

export default AnalysisQuestion;
